const headingColorsList = [
  { name: 'white', value: '#ffffff', border: 'var(--card-border-color)' },
  { name: 'black', value: '#333333' },
  { name: 'red', value: '#FF073A' },
  { name: 'blue', value: '#475F94' },
  { name: 'yellow', value: '#FFAB0F' },
  { name: 'green', value: '#32BF84' },
  { name: 'purple', value: '#212D96' },
  { name: 'slate', value: '#718199' },
];

export default headingColorsList;
